import React, { FC } from 'react'
import classNames from 'classnames'

import StylesModule from 'components/lv2/imageGrid.module.scss'

export interface SquareBgProps {
  addClassName: string
}

const SquareBg: FC<SquareBgProps> = ({ children, addClassName }) => {
  return (
    <div
      className={classNames(StylesModule.imageGrid, StylesModule[addClassName])}
    >
      {children}
    </div>
  )
}

export default SquareBg
